import React, { useContext } from 'react';
import { LoaderContext } from '../../Services/Loader_Provider_Service/LoadingContext';

const ComponentLoader = () => {
  return (
    <div className='loader-main'>
      <div className="loader-wave">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default ComponentLoader;

